import React from 'react';
import logo from '../images/logo.jpg';

const LogoIcon = () => (
  <img src={logo} alt="Logo" />
);

export default LogoIcon;
